import React, { useEffect, useRef, useState } from 'react';
import Save from "../../assets/save.svg";
import AttachmentModalProps from "./AttachmentModalProps";
import { Modal } from 'flowbite-react';
import { ZoomHandler, ZoomMode, cursorImage } from '../../helpers/zoomHelpers'

export const RenderImage = ({ media, file_obj, disabled, component, onRemove }: AttachmentModalProps) => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const imageRef = useRef<HTMLImageElement>(null);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [scale, setScale] = useState(1);
    const [zoomMode, setZoomMode] = useState(ZoomMode.IN);
    const modalBodyClass = 'h-full p-0 w-full flex justify-center items-start overflow-auto';

    const openModal = (url: string) => {
        setSelectedImage(url);
    };

    const closeModal = () => {
        setSelectedImage(null);
        setScale(1);
        setZoomMode(ZoomMode.IN)
    };

    // Закрытие по клику вне модального окна
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                closeModal();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    function applyZooms(scale: number, event: React.MouseEvent<HTMLImageElement, MouseEvent>) {
        const container = modalRef?.current?.getElementsByClassName(modalBodyClass)[0];
        const content = imageRef?.current;

        if (container && content) {
            new ZoomHandler().applyZooms(
                scale,
                event,
                container,
                content
            )
        } else {
            console.error('Container or content not found');
        }
    }

    const handleImageClick = (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        switch (zoomMode) {
            case ZoomMode.DISABLE:
                break
            case ZoomMode.IN:
                const newScaleValue = scale + 1;
                setScale(newScaleValue);
                applyZooms(newScaleValue, event);
                setZoomMode(ZoomMode.OUT)
                break
            case ZoomMode.OUT:
                if (scale > 1) {
                    const newScale = scale - 1;
                    setScale(newScale);
                    applyZooms(newScale, event);
                    setZoomMode(ZoomMode.IN)
                }
                break
        }
    };

    return (
        <>
            {media && component({ media: media, onClick: () => openModal(media.file) })}
            {file_obj && component({
                file_obj: file_obj,
                disabled: disabled,
                onRemove: onRemove,
                onClick: () => openModal(file_obj.media_info.file)
            })}
            {/* Модальное окно на весь экран для картинок */}
            <Modal
                size={'6xl'}
                show={selectedImage !== null}
                ref={modalRef}
                style={{
                    transformOrigin: '0 0'
                }}
                onClose={closeModal}>
                <Modal.Header
                    className={"w-full flex flex-[0_0_auto] overflow-hidden whitespace-pre-wrap break-word-only-long"}
                >
                    {media && media.original_name}
                    {file_obj && file_obj.media_info.original_name}
                </Modal.Header>
                <Modal.Body
                    className={modalBodyClass}
                    style={{
                        transformOrigin: '0 0'
                    }}
                >
                    <img
                        src={selectedImage || ''}
                        ref={imageRef}
                        alt='preview'
                        onClick={handleImageClick}
                        style={{
                            transform: `scale(${scale})`,
                            transformOrigin: '0 0',
                            width: 'auto',
                            height: 'auto',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            position: 'relative',
                            cursor: cursorImage(zoomMode)
                        }}
                        className="min-h-[20vh] min-w-[20vw] max-h-[75vh] max-w-[80vw] object-contain"
                    />
                </Modal.Body>
                <Modal.Footer className="w-full flex flex-[0_0_auto]">
                    <div className="flex w-full justify-center gap-2">
                        <a
                            className="w-10 p-2 flex flex-row justify-center items-center gap-1 text-black rounded-lg bg-melon-yellow hover:bg-yellow-400"
                            href={media?.file || file_obj?.media_info.file}
                            target={'_blank'}
                        >
                            <img src={Save} alt="download file" />
                        </a>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}
